// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3FBAo","bigColWidth":"Table_bigColWidth__1iB75","biggerColWidth":"Table_biggerColWidth__3wxSA","row":"Table_row__3GjgA","col":"Table_col__1r2ep"};